export default __webpack_public_path__ + "static/media/1787.6f7fa8a5.png";